import React, { useState } from "react";
import ButtonFetch from './ButtonFetch.jsx';
import Checkbox from "./Checkbox.jsx";
import "./css/pathFetch.css"

/*
expected props
    pathInitial            path string to put in input field
    checkInitial           initial checkbox state for "Force Refresh"
    handlePathResults      callback "Load" button clicked; expects 2 element array: [pathName, checked]
    shortcuts              array of ShortcutDefs, describing shortcut buttons to show
 */
export default function PathNameFetch({
        pathInitial='',
        initialBooleanRefresh= false,
        initialBooleanUseLocalCache=false,
        className= null,
        handlePathResults,
        shortcuts=[],
        placeholder='',

        options = {
            showShortcuts: false,
            showUseLocalCache: false,
        }
}) {

    const [pathName, setPathName] = useState(pathInitial); // init with passed in name
    const [checkboxRefresh, setCheckboxRefresh] = React.useState(initialBooleanRefresh);
    const [checkboxUseLocalCache, setCheckboxUseLocalCache] = React.useState(initialBooleanUseLocalCache);
    const [showShortcuts, setShowShortcuts] = React.useState(options.showShortcuts ?? false);

    const handleCheckChangeRefresh = () => {
        setCheckboxRefresh(!checkboxRefresh);
    };

    const handleCheckChangeUseLocalCache = () => {
        setCheckboxUseLocalCache(!checkboxUseLocalCache);
    };

    const returnResults = () => {
        handlePathResults([pathName, checkboxRefresh, checkboxUseLocalCache])
    }

    const myHandlePath = {
        handleChange : (event) => {
            // console.log("PathNameFetch::myHandleFetch.handleChange, event.target.value is:" + event.target.value)
            setPathName(event.target.value); // set component-local version of fileName
        },

        // interpret Enter as submit button
        handleKeyPress : (event) => {
            let key = event.key;
            if (key === "Enter") {
                // console.log("PathNameFetch::myHandleFetch.handleKeyPress: submitting via enter-key")
                returnResults()
            }
        },

        // submit form by calling event handler for pathName, handlePathName
        handleSubmit : (event) => {
            // console.log("PathNameFetch::myHandleFetch.handleSubmit, pathName is:" + pathName)
            returnResults()
        }
    };

    const shortcutsButton = <button
        className={"utility-button small-button"}
        style={{margin: "0 0 0.2rem 10px"}}
        onClick={() => {setShowShortcuts(prevState => !prevState)}} >
        <span>{showShortcuts ? "Hide Shortcuts" : "Show Shortcuts"}</span>
    </button>

    const shortcutsDisplay = showShortcuts && shortcuts?.length
        ? <div className="shortcuts-display">
            {shortcuts.map ( shortCutDef => {
                return <ButtonFetch key={shortCutDef.value} buttonDef={shortCutDef} onClick={setPathName} className={"path-shortcut"}/>
            })
            }
            {/*{shortcutsButton}*/}
        </div>
        : null

    const UseLocalCacheDisplay = options.showUseLocalCache
        ? <Checkbox className={"chk-checkbox chk-use-local-cache"} label={"Use Local Cache for Source"} value={checkboxUseLocalCache} onChange={handleCheckChangeUseLocalCache}/>
        : null


    const buttonLoadReferences = <button
        className={"utility-button"}
        style={{margin: "0 0 0.2rem 10px"}}
        onClick={myHandlePath.handleSubmit}>
        <span>{"Load References"}</span>
    </button>

    return <div className={`path-fetch${className ? ` ${className}` : ''}`}>

        <div className={"path-fetch-wrap"}>

            <div className={"path-input-wrapper"}><label
                    htmlFor="pathInput" id={'pathInput-label'}>URL: </label
                ><input
                    id="pathInput" name="pathInput"
                    type="search"
                    className="iare-input"
                    list="shortcuts-list"
                    autoComplete="on"
                    value={pathName}
                    onChange={myHandlePath.handleChange}
                    onKeyPress={myHandlePath.handleKeyPress} // TODO deprecated - should change to onKeyDown
                    placeholder = {placeholder ? placeholder : ''}
                />
                {/*<datalist id="shortcuts-list">*/}
                {/*    { shortcuts.map( sc => <option key={sc.value} value={sc.value} /> )}*/}
                {/*</datalist>*/}

            </div>

            <div style={{display: "block"}}>
                {buttonLoadReferences}
                <Checkbox className={"chk-checkbox chk-force-refresh"} label={"Force Refresh"} value={checkboxRefresh} onChange={handleCheckChangeRefresh}/>
                {UseLocalCacheDisplay}
                {shortcutsButton}
            </div>

            {shortcutsDisplay}

        </div>

    </div>

}
